import React from 'react';
import { IconShield } from '@groupelacentrale/contact-storybook/lib/icons';
import './PublicationOption.scss';
import arrow from 'assets/PublicationOptions/arrow.svg';

export const PublicationOptionSecuritel: React.FC<{ number: string }> = ({ number }) => {
  return (
    <div className="securitel-picture">
      <div>{number}</div>
      <div className="replacement-number">
        <IconShield width={20} />
        <span className="number">01 02 03 04 05</span>
      </div>
      <img className="arrow" src={arrow} alt="" />
    </div>
  );
};
